import React, { useState } from 'react';

const useModal = () => {
    const [modalActive, setModalActive] = useState(false);
    const [onEnd, setOnEnd] = useState(() => {})
    return { modalActive, setModalActive };
};

export default useModal;
